import { API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { toast } from "react-toastify";
import {
  activateNoShowReportQueryFn,
  resolveNoShowReportQueryFn,
  updateNoShowReportCommentQueryFn,
} from "./noShowReportQueries";

export const updateNoShowReportComment = async (
  pk: string,
  date: string,
  comment: string
) => {
  const { variables, inputs, query } = updateNoShowReportCommentQueryFn(
    pk,
    date,
    comment
  );

  const myQuery = `mutation (${inputs}) {
        ${query}
        }`;

  try {
    const getUpdateResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getUpdateResponse.data.updateNoShowReportComment;
    if ("message" in response) {
      toast.error(`${response.message}`);
      return response;
    }
    return response;
  } catch (error: any) {
    toast.error(`Kunde inte uppdatera no-show: ${error.message}`);
    throw error;
  }
};

export const activateNoShowReport = async (
  PK: string,
  date: string,
  member_id: string
) => {
  const { query, inputs, variables } = activateNoShowReportQueryFn(
    PK,
    date,
    member_id
  );
  const myQuery = `mutation (${inputs}) {
        ${query}
        }`;
  try {
    const getActivateResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getActivateResponse.data.activateNoShowReport;

    if ("message" in response) {
      toast.error(response.message);
      return response;
    }
    return response;
  } catch (error: any) {
    toast.error(`Kunde inte aktivera no-show: ${error.message}`);
    throw error;
  }
};

export const resolveNoShowReport = async (
  PK: string,
  date: string,
  member_id: string
) => {
  const { query, inputs, variables } = resolveNoShowReportQueryFn(
    PK,
    date,
    member_id
  );
  const myQuery = `mutation (${inputs}) {
        ${query}
        }`;
  try {
    const getResolveResponse = (await API.graphql({
      query: myQuery,
      variables: variables,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;

    const response = getResolveResponse.data.resolveNoShowReport;

    if ("message" in response) {
      toast.error(response.message);
      return response;
    }
    return response;
  } catch (error: any) {
    toast.error(`Kunde inte inaktivera no-show: ${error.message}`);
    throw error;
  }
};
